module.exports = __webpack_public_path__ + "img/pure_kretschmer.db7ca575.jpg";